<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>发货</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleBack">返回</el-button>
                </el-col>
            </el-row>

            <el-table :data="items">
                <el-table-column prop="id" label="ID">
                </el-table-column>
                <el-table-column prop="name" label="商品名称">
                </el-table-column>
                <el-table-column prop="productCount" label="数量">
                </el-table-column>
                <el-table-column inline-template :context="_self" label="已选择设备">
                    <div>
                        <p v-for="i in row.choosed" :key="i">{{i}}</p>
                    </div>
                </el-table-column>
                <el-table-column inline-template :context="_self" label="操作">
                    <el-button @click="handleChoose($index, row)" type="text" size="small">选择设备</el-button>

                </el-table-column>
            </el-table>

            <section class="installment" v-if="row.isAlipayMini && row.dispalyExtra">
                <div class="panel">
                     分期数：{{hasInstallmentCount}} / {{installmentCount}}
                </div>
                <div class="panel">
                    租金：{{(hasInstallmentCount * row.dispalyExtra.paidData.rental / installmentCount).toFixed(2)}} / {{row.dispalyExtra.paidData.rental}}
                </div>
                <el-tag type="danger" v-if="!canInstallment && !installmentDone">今日已扣款，请明日执行</el-tag>
                <el-tag type="success" v-if="installmentDone">扣款完成，可以发货</el-tag>
                <el-button v-if="!installmentDone" :disabled="!canInstallment" type="primary" @click="doInstallment">扣款</el-button>
            </section>

            <el-form :model="row">
                <el-form-item label="收件人：" label-width="100px">
                    <span>{{row.receiverName}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="100px">
                    <span>{{row.receiverTel}}</span>
                </el-form-item>
                <el-form-item label="地址：" label-width="100px">
                    <span>{{row.addressDetail.province + ' ' + row.addressDetail.city + ' ' + row.addressDetail.district + ' ' + row.addressDetail.fullAddress}}</span>
                </el-form-item>
            </el-form>
            <el-form :model="sendForm">
                <el-form-item label="运送方式" label-width="100px" prop="description">
                    <el-select v-model="wayValue" placeholder="请选择">
                        <el-option v-for="item in waysArr" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="wayValue === 'express'">
                    <el-form-item label="快递公司" label-width="100px" prop="description">
                        <el-select v-model="sendForm.shipper" placeholder="请选择">
                            <el-option v-for="item in expressArr" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="快递单号" label-width="100px">
                        <el-input v-model="sendForm.expressNumber"></el-input>
                    </el-form-item>
                   <el-form-item label="发货人" label-width="100px">
                            <el-input v-model="sendForm.operator"></el-input>
                        </el-form-item>
                    <el-form-item label-width="100px">
                        <el-button type="primary" @click="onSubmit">发货</el-button>
                    </el-form-item>
                </div>
                <div v-if="wayValue === 'self'">
                    <el-form-item label="快递单号" label-width="100px">
                        <el-input v-model="sendForm.expressNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="发货人" label-width="100px">
                            <el-input v-model="sendForm.operator"></el-input>
                        </el-form-item>
                    <el-form-item label-width="100px">
                        <el-button type="primary" @click="onSubmit">发货</el-button>
                    </el-form-item>
                </div>

            </el-form>

             <el-form>
                <el-form-item label="用户昵称：" label-width="180px">
                    <span>{{userInfo.nickName}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="180px">
                    <span>{{userInfo.username}}</span>
                </el-form-item>
                <el-form-item label="租赁时间：" label-width="180px" v-if="row.dispalyExtra && row.dispalyExtra.tenancy.length">
                    <el-tag type="gray">{{fromatDate(row.dispalyExtra.tenancy[0].begin)}}</el-tag>
                    <span class="line"></span>
                    <el-tag type="danger">{{rentDay}}天</el-tag>
                    <span class="line"></span>
                    <el-tag type="gray" v-if="row && row.dispalyExtra && row.dispalyExtra.tenancy">{{fromatDate(row.dispalyExtra.tenancy[0].end)}}</el-tag>
                </el-form-item>
                <el-form-item label="租金(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.rental}}</span>
                </el-form-item>
                <el-form-item label="优惠券抵扣(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.discount}}</span>
                </el-form-item>
                <el-form-item label="押金(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.deposit}}</span>
                </el-form-item>
                <el-form-item label="减免押金(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.depositDiscount}}</span>
                </el-form-item>
                <el-form-item label="费用统计(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paymount}}</span>
                </el-form-item>
            </el-form>
        </div>

        <el-dialog title="添加设备" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="选择仓库" label-width="100px">
                    <el-select v-model="storage" placeholder="请选择" @change="storageChange">
                        <el-option v-for="item in storageArr" :key="item.id" :label="item.storageName" :value="item.id">
                            <span style="float: left">{{ item.storageName }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择设备" label-width="100px" v-if="storage">
                    <el-select v-model="value5" multiple placeholder="请选择">
                        <el-option v-for="item in options" :key="item.productId" :label="item.deviceId" :value="item.productId">
                            <span style="float: left">{{ item.deviceId }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">序列号</span>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureNow">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getOrderId,
        getExpress,
        getUsersDetail,
        getExpressD,
        getStoragesId,
        deleteOrder,
        putExpress,
        cancelOrder,
        backOrder,
        getProducts,
        sendExpress,
        getStoragesList,
        doInstallment
    } from '../../api/version'

    export default {
        data() {
            return {
                curId: '',
                row: {},
                wayValue: '',
                sendForm: {
                    shipper: ''
                },
                userInfo: {},
                rentDay: '',
                form: {},
                dialogFormVisible: false,
                storageArr: [],
                storage: '',
                waysArr: [{
                    value: 'self',
                    name: '自提'
                }, {
                    value: 'express',
                    name: '快递'
                }],
                expressArr: [{
                    value: 'SF',
                    name: '顺丰'
                }],
                options: [],
                value5: [],
                items: [],
                cur: '',
                canInstallment: true,
                installmentCount: 0,
                hasInstallmentCount: 0,
                installmentDone: false
            }
        },
        created() {

            getStoragesList(sessionStorage.userId).then(res => {
                this.storageArr = res.data
            })

            getOrderId(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res, 'd')
                if(res.data.isAlipayMini) {
                    res.data.dispalyExtra.paidData.installmentHistory = res.data.dispalyExtra.paidData.installmentHistory.filter((item) => {
                        return !item.isFinishLose;
                    });
                    let canInstallment = true;
                    let installmentCount = Math.floor(res.data.dispalyExtra.paidData.rental / 2000 ) + 1;
                    let installmentHistory = res.data.dispalyExtra.paidData.installmentHistory;
                    let hasInstallmentCount = installmentHistory.length;
                    if (res.data.isAlipayMini) {
                        if (installmentCount === hasInstallmentCount) {
                            canInstallment = false;
                        }
                        else if (hasInstallmentCount > 0){
                            canInstallment = !(installmentHistory[hasInstallmentCount - 1].created.substring(0, 10) == this.getDate());
                        }
                    }

                    this.canInstallment = canInstallment;
                    this.installmentCount = installmentCount;
                    this.hasInstallmentCount = hasInstallmentCount;
                    this.installmentDone = hasInstallmentCount === installmentCount;
                }

                this.row = res.data
                this.items = JSON.parse(JSON.stringify(this.row.orderItems));
                this.items.forEach(item => {
                    item.productIds = []
                    item.choosed = []
                })

                getUsersDetail(sessionStorage.userId, res.data.userId).then(res => {
                    this.userInfo = res.data
                })

                let day = ''

                if (res.data && res.data.dispalyExtra && res.data.dispalyExtra.tenancy.length) {
                    console.log(res.data.dispalyExtra.tenancy, 'f')
                    day = parseInt((new Date(res.data.dispalyExtra.tenancy[0].end) - new Date(res.data.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                    this.rentDay = day === 0 ? '1' : day + 1
                }

                if (res.data.delivery && res.data.delivery.sendShipper) {
                    let filter = {
                        'where': {
                            'expressNum': res.data.delivery.sendExpressNum,
                            'shipper': res.data.delivery.sendShipper
                        }
                    }

                    console.log(filter)
                    getExpress(sessionStorage.userId, JSON.stringify(filter)).then(res => {
                        console.log(res.data)
                        this.expressData = res.data[0]

                    })
                }
            })
        },
        methods: {
            fromatDate(str) {
                function double(val) {
                    if (val > 9) {
                        return val;
                    }
                    return '0' + val;
                }

                const d = new Date(str);
                const year = d.getFullYear();
                const month = d.getMonth() + 1;
                const date = d.getDate();

                return double(year) + '-' + double(month) + '-' + double(date);
            },
            handleBack() {
                history.go(-1)
            },
            getDate() {
                const d = new Date();
                const year = d.getFullYear();
                const month = d.getMonth() + 1;
                const date = d.getDate();
                const double = (val) => {
                    if (val > 9) {
                        return val;
                    }
                    return '0' + val;
                }

                return double(year) + '-' + double(month) + '-' + double(date);
            },
            storageChange(val) {
                console.log(val)
                getProducts(sessionStorage.userId, JSON.stringify({
                    'where': {
                        'productDetailId': this.curId,
                        'isOnline': true,
                        'storageId': this.storage
                    }
                })).then(res => {
                    this.options = res.data
                })
            },
            handleChoose(index, row) {
                if (this.row.isAlipayMini && this.canInstallment) {
                    return this.$message.error(`请先执行扣款操作`);
                }

                this.dialogFormVisible = true

                this.value5 = JSON.parse(JSON.stringify(row.productIds))
                this.storage = row.storage
                this.cur = index
                this.curId = row.productDetailId
            },
            doInstallment() {
                doInstallment(this.row.id, sessionStorage.userId).then((res) => {
                    if (res.data.result === 'success') {
                        this.$message.success(`扣款操作成功`);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000)
                    }
                });
            },
            sureNow() {
                if(this.value5.length !== this.items[this.cur].productCount) {
                    this.$message.error(`该商品只能选择${this.items[this.cur].productCount}个设备`)
                }else {
                    this.items[this.cur].productIds = JSON.parse(JSON.stringify(this.value5))
                this.items[this.cur].storageIds = this.storage
                this.value5.forEach( item => {
                    this.options.forEach( item2 => {
                        if(item === item2.productId) {
                            this.items[this.cur].choosed.push(item2.deviceId)
                        }
                    })
                })
                console.log(this.items[this.cur])
                this.dialogFormVisible = false
                }

            },
            onSubmit() {
                if (this.row.isAlipayMini && this.canInstallment) {
                    return this.$message.error(`请先执行扣款操作`);
                }
                if (!this.sendForm.expressNumber) {
                    this.$message.error('请填写快递单号')
                } else if (this.wayValue != 'self' && !this.sendForm.shipper) {
                    this.$message.error('请选择快递公司')
                } else if ( !this.sendForm.operator) {
                    this.$message.error('请填写发货人')
                }else {
                    this.sendForm.products = []
                    console.log(this.items,'itm')

                    for(var i=0;i<this.items.length;i++) {
                        if(!this.items[i].choosed.length){
                            this.$message.error('请选择设备');
                            return false;
                        }
                        this.sendForm.products.push({
                            orderItemId: this.items[i].id,
                            productIds: this.items[i].productIds
                        })
                    }

                    this.items.forEach((item,index) => {

                    })
                    console.log(this.wayValue)
                    if(this.wayValue === 'self') {
                        this.sendForm.shipper = 'SELF'
                    }

                    this.$confirm('此操作将确认发货, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    sendExpress(sessionStorage.userId, this.$route.params.id, this.sendForm).then( res => {
                        console.log(res.data)
                        if(res.data) {
                            this.$message({
                                message: '已发货',
                                type: 'success'
                            });
                            this.$router.push('/orderExpress')
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消发货'
                    });
                });


                }


            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .top-header {
        overflow: hidden;
    }

    .top-header p.text-left {
        float: left;
    }

    .top-header .el-select {
        float: right;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .border {
        border-bottom: 1px solid #000;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .line {
        display: inline-block;
        height: 1px;
        width: 20px;
        border-top: 1px solid #000;
        vertical-align: middle;
        margin: 0 10px;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
    .installment {
        padding: 20px 0px;
    }
    .panel {
        display: inline-block;
        margin-right: 20px;
        padding: 10px 20px;
        font-size: 14px;
        color: #fff;
        background-color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// SendExpress.vue?61a32a03